import service from '@/api/request';
import { defineExportApi, definePostApi } from '../utils/define';

/** 赛程枚举 */
export type Period = 0 | 1 | 2;
/** 赛程说明：0-热身赛，1-初赛，2-复赛 */

/** 中金所杯赛事列表项 */
export interface ZjsCompListItem {
  /** 赛事id */ compId: number;
  /** 赛事名称 */ compName: string;
}

/**
 * 查询中金所杯赛事列表（用于前端赛事选择下拉框）
 * @description 无入参
 */
export const getZjsCompList = () =>
  service.post<null, ZjsCompListItem[]>('/api/zjs/getZjsCompList', null, { mock: false });

export interface VerifyItem {
  cardList: string[];
  id: number;
  idCard: string;
  userName: string;
  oscTypeStr: string;
  reason: string;
  verifyStatus: number;
  verifyStatusStr: string;
  verifyReason: number;
  note: string;
  /** 指导老师 */
  advisor?: string;
}
/** 证件审核分页查询 请求参数 */
export interface CertificateListRequest {
  /** 赛事id */ compId: number;
  current?: number;
  size?: number;
}
export const getCertificateList = (data: CertificateListRequest) =>
  service.post<CertificateListRequest, Global.RecordResponse<VerifyItem>>('/api/osCard/list', data, { mock: false });

export const getCertificateCardList = data => service.post('/api/osCard/cardInfo', data, { mock: false });

export const cffeCertificateVerify = data => service.post('/api/osCard/verify', data, { mock: false });

export const getInvDrawData = data => service.post('/api/inv/getInvDrawData', data);
/** 确认复赛成绩 请求参数（compId + period） */
export interface ConfirmFinalResultsRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
}
// 确认复赛成绩
export const confirmFinalResults = (data: ConfirmFinalResultsRequest) =>
  service.post('/api/zjs/admin/confirmFinalResults', data, { mock: false });

/** 取消复赛成绩 请求参数（compId + period） */
export interface CancelFinalResultsRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
}
// 取消复赛成绩
export const cancelFinalResults = (data: CancelFinalResultsRequest) =>
  service.post('/api/zjs/admin/cancelFinalResults', data, { mock: false });

/** 确认总奖名单 请求参数（compId + period） */
export interface ConfirmFinalRewardRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
}
// 确认总奖名单
export const confirmFinalReward = (data: ConfirmFinalRewardRequest) =>
  service.post('/api/zjs/admin/confirmFinalReward', data, { mock: false });

/** 取消总奖名单 请求参数（compId + period） */
export interface CancelFinalRewardRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
}
// 取消总奖名单
export const cancelFinalReward = (data: CancelFinalRewardRequest) =>
  service.post('/api/zjs/admin/cancelFinalReward', data, { mock: false });
// 下载导入模版
export const downloadTemplate = (pramas: { templateType: string }) =>
  service.post<{ templateType: string }>('/api/common/downloadTemplate', pramas, {
    download: true,
    responseType: 'blob',
  });

/** 管理员-上传复赛名单 - 响应数据类型 */
export type UploadGradeListResponse = {
  code: number;
  message: string;
  success: boolean;
};

/**
 * 管理员-上传复赛名单
 * @param params FormData 包含 file, compId, period
 */
export const uploadGradeList = (params: FormData) =>
  service.post<FormData, UploadGradeListResponse>('/api/zjs/admin/importFinalResult', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

/** 管理员-上传获奖名单 - 响应数据类型 */
export type UploadAwardListResponse = {
  code: number;
  message: string;
  success: boolean;
};

/**
 * 管理员-上传获奖名单
 * @param params FormData 包含 file, compId, period
 */
export const uploadAwardList = (params: FormData) =>
  service.post<FormData, UploadAwardListResponse>('/api/zjs/admin/importFinalReward', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export interface signInfoItem {
  starPhone?: string;
  province?: string;
  provinceId?: string;
  orgId?: string;
  department: string;
  stuNum: string;
  city: string;
  /** 指导老师 */
  advisor?: string;
}

/** 管理员-报名信息查询 请求参数 */
export interface GetAdminSignupListRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛（不填默认初赛逻辑） */ period?: Period;
  current?: number;
  size?: number;
}
// 管理员-报名信息查询
export const getAdminSignupList = (data: GetAdminSignupListRequest) =>
  service.post<GetAdminSignupListRequest, Global.RecordResponse<signInfoItem>>('/api/zjs/queryAdminSignInfo', data, {
    mock: false,
  });

/** 管理员-晋级名单查询 请求参数 */
export interface GetAdminPromListRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 管理员-晋级名单查询
export const getAdminPromList = (data: GetAdminPromListRequest) =>
  service.post<GetAdminPromListRequest, Global.RecordResponse<signInfoItem>>('/api/zjs/queryAdminPromList', data, {
    mock: false,
  });

/** 领队-晋级名单查询 请求参数 */
export interface GetTeamPromListRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 领队-晋级名单查询
export const getTeamPromList = (data: GetTeamPromListRequest) =>
  service.post<GetTeamPromListRequest, Global.RecordResponse<signInfoItem>>('/api/zjs/queryTeamPromList', data, {
    mock: false,
  });

/** 管理员-复赛成绩查询 请求参数 */
export interface QueryFinalResultsRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 管理员-复赛成绩查询
export const queryFinalResultsByPage = (data: QueryFinalResultsRequest) =>
  service.post<QueryFinalResultsRequest, Global.RecordResponse<signInfoItem>>(
    '/api/zjs/admin/queryFinalResultsByPage',
    data,
    {
      mock: false,
    }
  );

/** 领队-复赛结果查询 请求参数 */
export interface QueryOrgFinalRewardRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 领队-复赛结果查询
export const queryOrgFinalRewardListByPage = (data: QueryOrgFinalRewardRequest) =>
  service.post<QueryOrgFinalRewardRequest, Global.RecordResponse<signInfoItem>>(
    '/api/zjs/team/queryOrgFinalRewardListByPage',
    data,
    {
      mock: false,
    }
  );

/** 管理员-获奖名单查询 请求参数 */
export interface QueryFinalRewardRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 管理员-获奖名单查询
export const queryFinalRewardListByPage = (data: QueryFinalRewardRequest) =>
  service.post<QueryFinalRewardRequest, Global.RecordResponse<signInfoItem>>(
    '/api/zjs/admin/queryFinalRewardListByPage',
    data,
    {
      mock: false,
    }
  );
/** 导出报名信息 请求参数 */
export type DownloadAdminSignResultsParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛（不填默认初赛逻辑） */ period?: Period;
};
/** 导出报名信息 */
export const downloadAdminSignResults = defineExportApi<DownloadAdminSignResultsParams>(
  '/api/zjs/downloadAdminSignInfo',
  'excel'
);

/** 管理员导出晋级名单 请求参数 */
export type DownloadAdminPromListParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 管理员导出晋级名单 */
export const downloadAdminPromList = defineExportApi<DownloadAdminPromListParams>(
  '/api/zjs/downloadAdminPromList',
  'excel'
);

/** 管理员导出复赛成绩 请求参数 */
export type ExportFinalResultParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 管理员导出复赛成绩 */
export const exportFinalResult = defineExportApi<ExportFinalResultParams>('/api/zjs/admin/exportFinalResult', 'excel');

/** 领队导出复赛成绩 请求参数 */
export type ExportOrgFinalRewardParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 领队导出复赛成绩 */
export const exportOrgFinalReward = defineExportApi<ExportOrgFinalRewardParams>(
  '/api/zjs/team/exportOrgFinalReward',
  'excel'
);

/** 管理员导出获奖名单 请求参数 */
export type ExportFinalRewardParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 管理员导出获奖名单 */
export const exportFinalReward = defineExportApi<ExportFinalRewardParams>('/api/zjs/admin/exportFinalReward', 'excel');

/** 领队导出晋级名单 请求参数 */
export type DownloadTeamPromListParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 领队导出晋级名单 */
export const downloadTeamPromList = defineExportApi<DownloadTeamPromListParams>(
  '/api/zjs/downloadTeamPromList',
  'excel'
);
/** 获取信息详情 请求参数 */
export interface GetAdminSignupDetailRequest {
  /** 赛事id */ compId: number;
  /** 报名id */ rid: string;
}
// 获取信息详情
export const getAdminSignupDetail = (data: GetAdminSignupDetailRequest) =>
  service.post<GetAdminSignupDetailRequest, string>('/api/zjs/queryStuDetailInfo', data, { mock: false });

/** 管理员编辑学生信息 请求参数 */
export interface EditAdminStuInfoRequest {
  /** 赛事id */
  compId: number | undefined;
  department: string;
  name?: string;
  orgId: number | string;
  rid: string;
  uid?: string;
  city: string;
  province?: string;
  provinceId?: number;
  stuNum: string;
  /** 指导老师（非必填，仅管理员编辑支持） */
  advisor?: string;
}
export const editAdminStuInfo = definePostApi<EditAdminStuInfoRequest, string>('/api/zjs/editAdminSignInfo');

/** 管理员-期货模拟交易查询 请求参数 */
export interface GetAdminTradeListRequest {
  /** 赛事id */ compId: number;
  current?: number;
  size?: number;
}
// 管理员-期货模拟交易查询
export const getAdminTradeList = (data: GetAdminTradeListRequest) =>
  service.post<GetAdminTradeListRequest, Global.RecordResponse<any>>('/api/zjs/queryAdminFuturesInfo', data, {
    mock: false,
  });

/** 管理员-期货模拟信息导出 请求参数 */
export type DownloadAdminTradeResultsParams = {
  /** 赛事id */ compId: number;
};
/** 导出期货模拟信息 */
export const downloadAdminTradeResults = defineExportApi<DownloadAdminTradeResultsParams>(
  '/api/zjs/downloadAdminFuturesInfo',
  'excel'
);

/** 管理员-知识答题查询 请求参数 */
export interface GetAdminKnowledgeListRequest {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
  current?: number;
  size?: number;
}
// 管理员-知识答题查询
export const getAdminKnowledgeList = (data: GetAdminKnowledgeListRequest) =>
  service.post<GetAdminKnowledgeListRequest, Global.RecordResponse<any>>('/api/zjs/queryAdminFkcInfo', data, {
    mock: false,
  });

/** 管理员-知识答题信息导出 请求参数 */
export type DownloadAdminKnowledgeResultsParams = {
  /** 赛事id */ compId: number;
  /** 赛程：0-热身赛，1-初赛，2-复赛 */ period: Period;
};
/** 导出知识答题信息 */
export const downloadAdminKnowledgeResults = defineExportApi<DownloadAdminKnowledgeResultsParams>(
  '/api/zjs/downloadAdminFkcInfo',
  'excel'
);

/** 领队-报名信息查询 请求参数 */
export interface GetLeaderSignupListRequest {
  /** 赛事id */ compId: number;
  current?: number;
  size?: number;
}
// 领队-报名信息查询
export const getLeaderSignupList = (data: GetLeaderSignupListRequest) =>
  service.post<GetLeaderSignupListRequest, Global.RecordResponse<VerifyItem>>('/api/zjs/queryTeamSignInfo', data, {
    mock: false,
  });

/** 领队-导出报名信息 请求参数 */
export type DownloadLeaderSignResultsParams = {
  /** 赛事id */ compId: number;
};
/** 导出报名信息 */
export const downloadLeaderSignResults = defineExportApi<DownloadLeaderSignResultsParams>(
  '/api/zjs/downloadTeamSignInfo',
  'excel'
);

/** 领队编辑学生信息 请求参数 */
export interface EditTeamStuInfoRequest {
  /** 赛事id */ compId: number;
  department: string;
  name?: string;
  orgId: number | string;
  rid: string;
  city: string;
  province?: string;
  provinceId?: number;
  stuNum: string;
}
export const editTeamStuInfo = definePostApi<EditTeamStuInfoRequest, string>('/api/zjs/editTeamSignInfo');

/** 领队-期货模拟信息查询 请求参数 */
export interface GetLeaderTradeListRequest {
  /** 赛事id */ compId: number;
  current?: number;
  size?: number;
}
// 领队-期货模拟信息查询
export const getLeaderTradeList = (data: GetLeaderTradeListRequest) =>
  service.post<GetLeaderTradeListRequest, Global.RecordResponse<any>>('/api/zjs/queryTeamFuturesInfo', data, {
    mock: false,
  });

/** 领队-期货模拟信息导出 请求参数 */
export type DownloadLeaderTradeResultsParams = {
  /** 赛事id */ compId: number;
};
/** 导出期货模拟信息 */
export const downloadLeaderTradeResults = defineExportApi<DownloadLeaderTradeResultsParams>(
  '/api/zjs/downloadTeamFuturesInfo',
  'excel'
);

/** 领队-知识答题信息查询 请求参数 */
export interface GetLeaderKnowledgeListRequest {
  /** 赛事id */ compId: number;
  current?: number;
  size?: number;
}
// 领队-知识答题信息查询
export const getLeaderKnowledgeList = (data: GetLeaderKnowledgeListRequest) =>
  service.post<GetLeaderKnowledgeListRequest, Global.RecordResponse<any>>('/api/zjs/queryTeamFkcInfo', data, {
    mock: false,
  });

/** 领队-知识答题信息导出 请求参数 */
export type DownloadLeaderKnowledgeResultsParams = {
  /** 赛事id */ compId: number;
};
/** 导出知识答题信息 */
export const downloadLeaderKnowledgeResults = defineExportApi<DownloadLeaderKnowledgeResultsParams>(
  '/api/zjs/downloadTeamFkcInfo',
  'excel'
);

/** 领队-电子证书分页查询 */
export const getCertDigitalList = data =>
  service.post<null, Global.RecordResponse<any>>('/api/certDigital/pageList', data, { mock: false });
/** 领队-电子证书一键下载 */
export const downloadCertDigitalList = (params: { raceId: string }) =>
  service.post<{ raceId: string }>('/api/certDigital/download', params, {
    download: true,
    responseType: 'blob',
  });
/** 领队-支持赛项查询 */
export const querySupportRace = data =>
  service.post<null, Array<any>>('/api/certDigital/querySupportRace', data, { mock: false });
/** 领队-电子证书单个下载 */
export const downloadSingle = (params: { raceId: string; fileName: string }) =>
  service.post<{ raceId: string; fileName: string }>('/api/certDigital/downloadSingle', params, {
    download: true,
    responseType: 'blob',
  });
